// extracted by mini-css-extract-plugin
module.exports = {"noChat":"style_noChat__3NVru"};